(function () {
  'use strict';

  function cmToIn(value) {
    var n = parseFloat(String(value).replace(',', '.').replace(/[^\d.]/g, ''));
    if (!isFinite(n) || n <= 0) return null;
    return Math.round((n / 2.54) * 10) / 10;
  }

  function cellLooksNumeric(text) {
    return /^\s*\d+([.,]\d+)?\s*(cm)?\s*$/i.test(String(text || '').trim());
  }

  function convertTable(table) {
    if (!table || table.getAttribute('data-msd-inches') === '1') return;
    var caption = table.querySelector('caption');
    var captionText = caption ? caption.textContent || '' : '';
    var headerText = Array.prototype.map.call(table.querySelectorAll('th'), function (th) {
      return th.textContent || '';
    }).join(' ').toLowerCase();
    var isCmTable = /centimeter|\bcm\b/.test(captionText.toLowerCase()) ||
      /centimeter|\bcm\b/.test(headerText) ||
      /divide centimeters by 2\.54/i.test((table.parentElement && table.parentElement.textContent) || '');

    if (!isCmTable) {
      var numericCells = 0;
      var sample = 0;
      Array.prototype.forEach.call(table.querySelectorAll('td'), function (td) {
        var t = (td.textContent || '').trim();
        if (cellLooksNumeric(t)) {
          numericCells += 1;
          var n = parseFloat(t.replace(',', '.'));
          if (n >= 40 && n <= 200) sample += 1;
        }
      });
      if (numericCells >= 6 && sample >= 4) isCmTable = true;
    }
    if (!isCmTable) return;

    Array.prototype.forEach.call(table.querySelectorAll('td, th'), function (cell) {
      var text = (cell.textContent || '').trim();
      if (!cellLooksNumeric(text)) return;
      if (/in|"/.test(text)) return;
      var inches = cmToIn(text);
      if (inches == null) return;
      cell.textContent = inches + '" (' + text.replace(/\s*cm$/i, '') + ' cm)';
    });

    if (caption) {
      caption.textContent = captionText
        .replace(/in centimeters/i, 'in inches (cm in parentheses)')
        .replace(/centimeters/i, 'inches (cm in parentheses)');
    }

    var note = table.parentElement && table.parentElement.querySelector('[data-msd-cm-note]');
    if (!note && table.parentElement) {
      Array.prototype.forEach.call(table.parentElement.querySelectorAll('p, li, span'), function (el) {
        if (/divide centimeters by 2\.54/i.test(el.textContent || '')) {
          el.textContent = 'Measurements shown in inches first, with centimeters in parentheses.';
          el.setAttribute('data-msd-cm-note', '1');
        }
      });
    }

    table.setAttribute('data-msd-inches', '1');
  }

  function run(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('table'), convertTable);
  }

  function boot() {
    run(document);
    var desc = document.querySelector('.product-page-info__description, [data-popup-size-guide-content]');
    if (desc && window.MutationObserver) {
      var observer = new MutationObserver(function () { run(desc); });
      observer.observe(desc, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () { run(document); });
})();
